import React from 'react';

/** The 52×28 square switch the page editor's settings panel uses. */
export default function SquareSwitch({ on, onChange, label }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={label}
      onClick={() => onChange(!on)}
      className="relative flex-shrink-0"
      style={{ width: 52, height: 28, border: '2px solid #FFFFFF', background: on ? '#00FFFF' : '#000000', transition: 'background-color 200ms' }}
    >
      <span className="absolute bg-black" style={{ width: 18, height: 18, top: 3, left: on ? 27 : 3, border: '2px solid #FFFFFF', transition: 'left 120ms' }} aria-hidden />
    </button>
  );
}
